import styled from 'styled-components';

export default styled.div`
    .trustly-iframe {
        width: 100%;
        height: 500px;
    }
`;
